export function replaceAllWithUndefined<T extends Record<string, any>>(
  obj: T
): { [K in keyof T]: T[K] | undefined } {
  const newObj: { [K in keyof T]: T[K] | undefined } = { ...obj };

  for (const key in newObj) {
    if (newObj[key] === "all") {
      newObj[key] = undefined;
    }
  }

  return newObj as { [K in keyof T]: T[K] | undefined };
}
